import "../styles/article.css";
import { PostCard } from "./PostCard";

export function Posts() {
  return (
    <div className="article">
      <PostCard
        commentCount={14}
        image={
          "https://pbs.twimg.com/profile_images/1361135449566105600/eJN6okzW_bigger.jpg"
        }
        likeCount={908}
        name={"Gaurav Thakur"}
        retweetCount={222}
        time={"11m"}
        username={"@gauravcodes"}
        description={
          "money makes you happier, chase titles or you'll get under-leveled, don't be loyal to a company because companies won't be loyal to you, ignore advice from the rich and powerful because it won't apply to you etc"
        }
      />
      <PostCard
        commentCount={14}
        image={
          "https://pbs.twimg.com/profile_images/1323891982637297665/vVSG0Dx8_bigger.jpg"
        }
        likeCount={81}
        name={"Kathei Pam"}
        retweetCount={32}
        time={"15m"}
        username={"@katheipam"}
        description={
          "Reading- McKinsey says Indian IT sector is expected to touch 300-350 billion $ in next 5 years.  Growth in next 5 will be higher than past 5. Cloud n digital will drive growth to 50 pct vs 30 pct share. Digital n cloud will be a 700 b $ opportunity."
        }
      />
      <PostCard
        commentCount={2}
        image={
          "https://pbs.twimg.com/profile_images/1115644092329758721/AFjOr-K8_bigger.jpg"
        }
        likeCount={8}
        name={"Jack"}
        retweetCount={2}
        time={"41m"}
        username={"@jack"}
        description={
          "Over 6,600 people submitted their proof-of-work so far. Working to narrow over weekend and will start interviewing board candidates soon."
        }
      />
      <PostCard
        commentCount={24}
        image={
          "https://pbs.twimg.com/profile_images/877373491820896256/93XcKIN3_bigger.jpg"
        }
        likeCount={8}
        name={"Robin Cangie"}
        retweetCount={122}
        time={"50m"}
        username={"@robinaula"}
        description={
          "Today is my 37th birthday, which is still quite young, but old enough, I suppose, to evoke the insecurities that accompany aging in our youth-driven culture. But I've been thinking today how underrated it is to grow older. It's such a privilege to become more of myself each year."
        }
      />
      <PostCard
        commentCount={34}
        image={
          "https://pbs.twimg.com/profile_images/883049860332609537/IsUISvAq_bigger.jpg"
        }
        likeCount={18}
        name={"Chris Coyier"}
        retweetCount={401}
        time={"56m"}
        username={"@chriscoyier"}
        description={
          "You ever wash silverware by just grabbing three of them randomly and spreading them out a little bit and then hitting one side with a soapy sponge, then the other, then kinda halfassing the handles before rinsing?"
        }
      />
      <PostCard
        commentCount={14}
        image={
          "https://pbs.twimg.com/profile_images/1361135449566105600/eJN6okzW_bigger.jpg"
        }
        likeCount={908}
        name={"Gaurav Thakur"}
        retweetCount={222}
        time={"11m"}
        username={"@gauravcodes"}
        description={
          "money makes you happier, chase titles or you'll get under-leveled, don't be loyal to a company because companies won't be loyal to you, ignore advice from the rich and powerful because it won't apply to you etc"
        }
      />
      <PostCard
        commentCount={14}
        image={
          "https://pbs.twimg.com/profile_images/1323891982637297665/vVSG0Dx8_bigger.jpg"
        }
        likeCount={81}
        name={"Kathei Pam"}
        retweetCount={32}
        time={"15m"}
        username={"@katheipam"}
        description={
          "Reading- McKinsey says Indian IT sector is expected to touch 300-350 billion $ in next 5 years.  Growth in next 5 will be higher than past 5. Cloud n digital will drive growth to 50 pct vs 30 pct share. Digital n cloud will be a 700 b $ opportunity."
        }
      />
      <PostCard
        commentCount={2}
        image={
          "https://pbs.twimg.com/profile_images/1115644092329758721/AFjOr-K8_bigger.jpg"
        }
        likeCount={8}
        name={"Jack"}
        retweetCount={2}
        time={"41m"}
        username={"@jack"}
        description={
          "Over 6,600 people submitted their proof-of-work so far. Working to narrow over weekend and will start interviewing board candidates soon."
        }
      />
      <PostCard
        commentCount={24}
        image={
          "https://pbs.twimg.com/profile_images/877373491820896256/93XcKIN3_bigger.jpg"
        }
        likeCount={8}
        name={"Robin Cangie"}
        retweetCount={122}
        time={"50m"}
        username={"@robinaula"}
        description={
          "Today is my 37th birthday, which is still quite young, but old enough, I suppose, to evoke the insecurities that accompany aging in our youth-driven culture. But I've been thinking today how underrated it is to grow older. It's such a privilege to become more of myself each year."
        }
      />
      <PostCard
        commentCount={34}
        image={
          "https://pbs.twimg.com/profile_images/883049860332609537/IsUISvAq_bigger.jpg"
        }
        likeCount={18}
        name={"Chris Coyier"}
        retweetCount={401}
        time={"56m"}
        username={"@chriscoyier"}
        description={
          "You ever wash silverware by just grabbing three of them randomly and spreading them out a little bit and then hitting one side with a soapy sponge, then the other, then kinda halfassing the handles before rinsing?"
        }
      />
    </div>
  );
}
